"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".callout_e8e64567 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_e8e64567 .ms-Suggestions{min-width:300px}\n" }]);
exports.callout = "callout_e8e64567";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/FloatingPicker/BaseFloatingPicker.scss.js
// module id = 1006
// module chunks = 0